import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

interface InfoProps {
  type?: 'warning' | 'information';
  text: string;
}

const BaseInfo: React.FC<InfoProps> = ({ type = 'information', text }) => {
  const styles = {
    warning: {
      bg: 'bg-[#FFF9EB]',
      text: 'text-[#E7810C]',
    },
    information: {
      bg: 'bg-[#EBF3FF]',
      text: 'text-[#2F78EE]',
    },
  };

  const { bg, text: textColor } = styles[type];

  return (
    <div className={`py-2.5 px-4 rounded-xl flex gap-2 items-center ${bg}`}>
      <MdInfoOutline size={20} className={textColor} />
      <p
        className={`font-normal text-sm ${textColor}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

export default BaseInfo;
